import { Box } from "@chakra-ui/react";

const CONFIG = {
  staging: {
    bg: "#b7791f",
    label: "STAGING ENVIRONMENT — isolated test data, safe to experiment",
  },
  production: {
    bg: "#c53030",
    label: "⚠ PRODUCTION DATA — this preview is connected to LIVE client data",
  },
};

export const EnvBanner = () => {
  const env = process.env.REACT_APP_HAKINA_ENV;
  const cfg = CONFIG[env];
  if (!cfg) return null;
  // The red PRODUCTION-DATA warning is for the internal preview workspace only.
  // Real clients on the deployed domain must never see it. The staging banner
  // stays host-independent on purpose: a staging build reaching any real
  // domain is a misdeploy we WANT loudly flagged.
  const isPreviewHost = window.location.hostname.endsWith(".emergentagent.com") || window.location.hostname === "localhost";
  if (env === "production" && !isPreviewHost) return null;
  return (
    <Box
      data-testid={`env-banner-${env}`}
      position="fixed"
      bottom="0"
      left="0"
      right="0"
      zIndex="2000"
      bg={cfg.bg}
      color="white"
      textAlign="center"
      fontSize="xs"
      fontWeight="bold"
      letterSpacing="0.08em"
      py="3px"
      px={2}
    >
      {cfg.label}
    </Box>
  );
};
